<template>
  <client-list
    :clients="filteredClients"
    :people="filteredPeopleForChat"
    :users="filteredUsersForChat"
    :groups="filteredGroupForChat"
    :others="others"
    :all="allChat"
    :chat-or-phone="'CHAT'"
    :show="show"
  />
</template>

<script>
import ClientList from "../../common/ClientList";
import { addNewChatAndCallMixin } from "../../../mixins/addNewChatAndCallMixin";

export default {
  name: "AddNewChat",
  mixins: [addNewChatAndCallMixin],
  props: {
    show: String // Which list to show
  },
  components: {
    ClientList
  }
};
</script>

<style scoped>
section >>> .phone-list-wrapper ul li {
  display: flex;
  justify-content: space-between;
}

section >>> .phone-list-wrapper ul li span.user-name-wrapper {
  display: inline;
}

form {
  padding: 10px;
  border-bottom: 1px solid #f2f2f2;
}

form span:last-of-type {
  margin-left: 30px;
}
</style>
